module.exports = __webpack_public_path__ + "static/testimonial-5-9ee4616c9b16ab7922c9a3a8dea98a97.png";